import React from 'react';
import { ReadinessResult } from '../types';

interface ReadinessSummaryProps {
  readiness: ReadinessResult;
  isChecking: boolean;
}

export const ReadinessSummary: React.FC<ReadinessSummaryProps> = ({ readiness, isChecking }) => {
  if (isChecking) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderRadius: '20px',
          background: 'rgba(99,102,241,0.10)',
          border: '1px solid rgba(99,102,241,0.20)',
          padding: '4px 14px',
          fontSize: '11px',
          fontWeight: 700,
          color: '#818CF8',
          whiteSpace: 'nowrap',
        }}
      >
        <span
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: '#818CF8',
            display: 'inline-block',
            animation: 'pulse 1s infinite',
            flexShrink: 0,
          }}
        />
        INITIALIZING PREFLIGHT ({readiness.passedCount}/{readiness.totalRequired} READY)
      </div>
    );
  }

  if (readiness.isReady) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderRadius: '20px',
          background: 'rgba(52,211,153,0.10)',
          border: '1px solid rgba(52,211,153,0.25)',
          padding: '4px 14px',
          fontSize: '11px',
          fontWeight: 700,
          color: '#34D399',
          whiteSpace: 'nowrap',
        }}
      >
        <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#34D399', display: 'inline-block', flexShrink: 0 }} />
        ALL SYSTEMS READY
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '20px',
        background: 'rgba(248,113,113,0.10)',
        border: '1px solid rgba(248,113,113,0.25)',
        padding: '4px 14px',
        fontSize: '11px',
        fontWeight: 700,
        color: '#F87171',
        whiteSpace: 'nowrap',
      }}
    >
      <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#F87171', display: 'inline-block', flexShrink: 0 }} />
      ACTION REQUIRED ({readiness.failedCount} BLOCKED)
    </div>
  );
};
